// API base URL. REACT_APP_API_URL (from .env) takes precedence when set,
// otherwise fall back to the per-environment defaults below.
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://flexicommunity.flexifunnels.com/api' // Production API
    : 'http://flexicommunity.local.com/api'); // Local API (matches /etc/hosts + Apache vhost)

const config = {
  API_URL: API_BASE_URL,

  VIRAL_SHARE_URL:
    process.env.NODE_ENV === 'production'
      ? 'http://flexicommunity.flexifunnels.com' // Production URL
      : 'http://localhost:3000', // Local URL

  // Community backend (flexicommunities / flexi2.0) — group collection + join API
  COMMUNITY_API_URL: API_BASE_URL,

  // GIPHY key for the post/comment GIF picker. Set REACT_APP_GIPHY_KEY in .env
  // for production; falls back to GIPHY's public demo key for local dev.
  GIPHY_KEY: process.env.REACT_APP_GIPHY_KEY || 'GlVGYHkr3WSBnllca54iNt0yFbjz7L65',
};

export default config;